import "styles/custom.css";
import * as React from "react";
import {
  getCurrentAADConfig,
  setAADConfig,
  getRegionNames,
  getCustomerPermissions,
} from "../components/Requests/Requests";
import {
  StandardScreen,
  StandardSearchBox,
  StandardDropdown,
  StandardButton,
  StatusMessage,
  PageLayout,
  StandardTable,
  StandardTableBody,
  StandardTableRow,
  StandardTableCell,
} from "../components/Layout";
import Theme from "../styles/theme";

class AADToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: "",
      message: "",
      currentAadStatus: "",
      versionToSet: "",
      spHostUrl: "",
      isEnabled: "",
      buttonText: "",
      regionNameChosen: "",
      regionNames: "",
      applyGlobalDefault: false,

      //Permissions Card
      tenantNamePermissions: "",
      regionNameChosenPermissions: "",
      errorPermissions: "",
      messagePermissions: "",
      loadingPermissions: "",
      permissionsData: null,

      //Filtering Permissions
      filterPermissionName: "",
      filterRetrievalMethod: "All",
      filterPermissionType: "All",
      selectedProducts: [],
      permissionSearchMode: "",

      //Paging
      currentPage: 1,
      pageSize: 5,
      totalCount: 0,
      totalPages: 0,

      //Table data - copied from Statistics
      tableRows: "",
      tableHeaders: "",
    };
    }

    productOptions = [
        { key: "ICP", text: "ICP" },
        { key: "Mobile", text: "Mobile" },
        { key: "CollabApp", text: "Collab App" },
        { key: "ContentConnector", text: "Content Connector" },
    ];

  componentDidMount() {
    this.initializeSettings();
  }

  initializeSettings() {
    this.getRegionNames();
  }

  async getCurrentAADConfig() {
    this.setState({ loading: true });
    let requestBody = {};
    requestBody = {
      SPHostUrl: this.state.spHostUrl,
      IsEnabled: this.state.isEnabled,
      RegionName: this.state.regionNameChosen,
    };
    let response = await getCurrentAADConfig(
      this.props.accessToken,
      requestBody,
    );
    let data = await response.json();
    if (response.status === 200) {
      if (data.message.includes("enabled")) {
        this.setState({
          loading: false,
          currentAadStatus: data,
          versionToSet: data === 0 ? 1 : 0,
          message: data.message,
          buttonText: "Disable",
        });
      } else if (data.message.includes("disabled")) {
        this.setState({
          loading: false,
          currentAadStatus: data,
          versionToSet: data === 0 ? 1 : 0,
          message: data.message,
          buttonText: "Enable",
        });
      } else {
        this.setState({
          loading: false,
          currentAadStatus: data,
          versionToSet: data === 0 ? 1 : 0,
          message: data.message,
          buttonText: "Add",
        });
      }
    } else {
      this.setState({ loading: false, error: "Something went wrong" });
    }
  }

  async setAADConfig() {
    this.setState({ loading: true });
    let requestBody = {};
    requestBody = {
      SPHostUrl: this.state.spHostUrl,
      IsEnabled: this.state.isEnabled,
      RegionName: this.state.regionNameChosen,
    };
    let response = await setAADConfig(this.props.accessToken, requestBody);
    let data = await response.json();
    if (response.status === 200) {
      this.setState({
        loading: false,
        currentAadStatus: data,
        versionToSet: data === 0 ? 1 : 0,
        message: data.message,
      });
    } else {
      this.setState({ loading: false, error: "Something went wrong" });
    }
    this.setState({ currentAadStatus: "" });
  }

  async getCustomerPermissions() {
    this.setState({
      loadingPermissions: true,
    });
    const requestBody = {
      Identifier: this.state.tenantNamePermissions,
      RegionName: this.state.regionNameChosenPermissions,
      PermissionName: this.state.filterPermissionName,
      PermissionSearchMode: this.state.filterPermissionName ? this.state.permissionSearchMode : null,
      RetrievalMethod:
        this.state.filterRetrievalMethod === "All"
          ? null
          : this.state.filterRetrievalMethod,
      PermissionType:
        this.state.filterPermissionType === "All"
          ? null
           : this.state.filterPermissionType,
      Products: this.state.selectedProducts.length > 0 ? this.state.selectedProducts : null,
      PageSize: this.state.pageSize,
      PageNumber: this.state.currentPage,
    };

    try {
      let response = await getCustomerPermissions(
        this.props.accessToken,
        requestBody,
      );
      if (response.status === 200) {
        let results = await response.json();
        const totalCount = results.count || 0;
        const totalPages = Math.ceil(totalCount / this.state.pageSize);
        this.setState({
          permissionsData: results.data,
          totalCount: totalCount,
          totalPages: totalPages,
          loadingPermissions: false,
        });
      } else {
        let errorText = await response.text();
        this.setState({
          errorPermissions: `Error ${response.status}: ${errorText}`,
          loadingPermissions: false,
          totalCount: 0,
          totalPages: 0,
          currentPage: 1,
        });
      }
    } catch (error) {
      this.setState({
        errorPermissions: "An unexpected error occurred.",
        loadingPermissions: false,
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
      });
    }
  }

  async getRegionNames() {
    this.setState({ loading: true });
    let response = await getRegionNames(this.props.accessToken);
    if (response.status === 200) {
      let data = await response.json();
      this.setState({
        loading: false,
        regionNames: data.map((item) => ({ key: item, text: item })),
      });
    } else {
      this.setState({
        loading: false,
        error: "Something went wrong",
        message: "",
      });
    }
  }

  onSelectRegionName = (event, item) => {
    this.setState({ regionNameChosen: item.key, message: "", error: "" });
  };

  onSelectRegionNamePermissions = (event, item) => {
    this.setState({
      regionNameChosenPermissions: item.key,
      messagePermissions: "",
      errorPermissions: "",
    });
  };

  onSpHostUrlChange = (newValue) => {
    this.setState({
      spHostUrl: newValue,
      message: "",
      error: "",
      currentAadStatus: "",
      buttonText: "",
      versionToSet: "",
    });
  };

  getResourceName(group) {
    if(!group) return "";
    const resourceTypeMap = {
      0: "Microsoft Graph",
      1: "SharePoint Online",
      2: "JWT Token",
    };
    return resourceTypeMap[group.resourceType] ?? `Unknown Resource (Type: ${group.resourceType})`;
  }

  // Pagination methods - copied from Statistics
  handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= this.state.totalPages) {
      this.setState({ currentPage: newPage }, () =>
        this.getCustomerPermissions(),
      );
    }
  };

  handlePreviousPage = () => {
    if (this.state.currentPage > 1) {
      this.handlePageChange(this.state.currentPage - 1);
    }
  };

  handleNextPage = () => {
    if (this.state.currentPage < this.state.totalPages) {
      this.handlePageChange(this.state.currentPage + 1);
    }
  };

  renderPageNumbers = () => {
    const { currentPage, totalPages } = this.state;
    const pageNumbers = [];
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);
    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }
    if (startPage > 1) {
      pageNumbers.push(
        <StandardButton
          key={1}
          text="1"
          onClick={() => this.handlePageChange(1)}
          disabled={1 === currentPage}
        />,
      );
      if (startPage > 2) {
        pageNumbers.push(
          <span key="ellipsis1" style={{ margin: "0 5px" }}>
            ...
          </span>,
        );
      }
    }
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <StandardButton
          key={i}
          text={String(i)}
          onClick={() => this.handlePageChange(i)}
          disabled={i === currentPage}
        />,
      );
    }
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(
          <span key="ellipsis2" style={{ margin: "0 5px" }}>
            ...
          </span>,
        );
      }
      pageNumbers.push(
        <StandardButton
          key={totalPages}
          text={String(totalPages)}
          onClick={() => this.handlePageChange(totalPages)}
          disabled={totalPages === currentPage}
        />,
      );
    }
    return pageNumbers;
  };

  renderPermissionsTable() {
    const { permissionsData } = this.state;
    if (!permissionsData || permissionsData.length === 0) return null;

    const columns = [
      "Tenant",
      "Product",
      "Application Permissions",
      "Delegated Permissions",
    ];

    return (
      <StandardTable>
        <thead>
          <tr style={{ backgroundColor: Theme.colors.background }}>
            {columns.map((column, index) => (
              <th
                key={index}
                style={{
                  border: `1px solid ${Theme.colors.border}`,
                  padding: "8px",
                  textAlign: "left",
                  fontWeight: Theme.typography.fontWeight.bold,
                  color: Theme.colors.text,
                }}
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <StandardTableBody>
          {permissionsData.map((item, index) => {
            const filteredAppPerms = item.permissions?.applicationPermissions?.filter(
              (group) => group.applicationPermissionList?.length > 0
            ) || [];
            const filteredDelegatedPerms = item.permissions?.allPrincipalDelegatedPermissions?.filter(
              (group) => group.delegatedPermissions?.length > 0
            ) || [];
            const emptyPermissionStyle = {
              background: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 10px,
                rgba(211, 47, 47, 0.08) 10px,
                rgba(211, 47, 47, 0.08) 20px
              )`,
            };

            return (
              <StandardTableRow key={index} index={index}>
                <StandardTableCell
                  style={{
                    wordBreak: "break-all",
                    fontWeight: Theme.typography.fontWeight.bold,
                    color: Theme.colors.primary,
                  }}
                >
                  {item.spHostUrl}
                </StandardTableCell>
                <StandardTableCell
                  style={{
                    fontWeight: Theme.typography.fontWeight.bold,
                    padding: "4px 8px",
                    backgroundColor: "#e8f4f8",
                    borderRadius: "4px",
                    minWidth: "120px",
                  }}
                >
                  {item.product || "N/A"}
                </StandardTableCell>
                <StandardTableCell
                  style={filteredAppPerms.length === 0 ? emptyPermissionStyle : {}}
                >
                  {filteredAppPerms.map((group, i) => (
                    <div key={i} style={{ marginBottom: "10px" }}>
                      <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                        {this.getResourceName(group)}
                      </div>
                      <ul style={{ paddingLeft: "20px", margin: 0 }}>
                        {group.applicationPermissionList?.map((perm, j) => (
                          <li key={j}>{perm}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </StandardTableCell>
                <StandardTableCell
                  style={filteredDelegatedPerms.length === 0 ? emptyPermissionStyle : {}}
                >
                  {filteredDelegatedPerms.map((group, i) => (
                    <div key={i} style={{ marginBottom: "10px" }}>
                      <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                        {this.getResourceName(group)}
                      </div>
                      <ul style={{ paddingLeft: "20px", margin: 0 }}>
                        {group.delegatedPermissions?.map((perm, j) => (
                          <li key={j}>{perm}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </StandardTableCell>
              </StandardTableRow>
            );
          })}
        </StandardTableBody>
      </StandardTable>
    );
  }

  render() {
    const {
      loading,
      error,
      message,
      spHostUrl,
      regionNameChosen,
      regionNames,
      currentAadStatus,
      buttonText,
      spHostUrlPermissions,
      regionNameChosenPermissions,
      errorPermissions,
      messagePermissions,
      loadingPermissions,
      tenantNamePermissions,
      filterRetrievalMethod,
      filterPermissionName,
      currentPage,
      pageSize,
      totalCount,
      totalPages,
      permissionsData,
    } = this.state;

    const retrievalMethodOptions = [
      { key: "All", text: "All Methods" },
      { key: 0, text: "Microsoft Graph" },
      { key: 1, text: "JWT Token Parsing" },
    ];

    const permissionTypeOptions = [
      { key: "All", text: "All Types" },
      { key: "Application", text: "Application" },
      { key: "Delegated", text: "Delegated" },
    ];

    return (
      <PageLayout>
        <StandardScreen
          title="Toggle Entra ID Setting"
          description="Enter the SP host url of the site you wish to enable/disable Entra ID for."
          loading={loading}
        >
          <StandardSearchBox
            label="SPHostUrl"
            placeholder="SPHostUrl"
            value={spHostUrl}
            onChange={this.onSpHostUrlChange}
          />

          <StandardDropdown
            label="Environment"
            selectedKey={regionNameChosen}
            onChange={this.onSelectRegionName}
            placeholder="Select Environment"
            options={regionNames}
            disabled={spHostUrl === ""}
          />

          <StandardButton
            text="Search"
            disabled={spHostUrl === "" || regionNameChosen === ""}
            onClick={() => this.getCurrentAADConfig()}
          />

          {message && <StatusMessage>{message}</StatusMessage>}

          {error && <StatusMessage type="error">{error}</StatusMessage>}

          {currentAadStatus !== null && currentAadStatus !== "" && (
            <StandardButton
              text={buttonText}
              disabled={spHostUrl === ""}
              onClick={() =>
                this.setAADConfig(spHostUrl, this.state.versionToSet)
              }
            />
          )}
        </StandardScreen>

        <StandardScreen
          title="Entra ID Permissions"
          description="View Customer Consented Permissions. Use filters below to find specific data."
          loading={loadingPermissions}
        >
          <StandardDropdown
            label="Environment"
            placeholder="Select Environment"
            selectedKey={regionNameChosenPermissions}
            options={regionNames}
            onChange={this.onSelectRegionNamePermissions}
          />

          <StandardSearchBox
            label="Tenant"
            placeholder="tenant.sharepoint.com"
            value={tenantNamePermissions}
            onChange={(newValue) =>
              this.setState({
                tenantNamePermissions: newValue,
                messagePermissions: "",
                errorPermissions: "",
              })
            }
          />

          <StandardDropdown
            label="Retrieval Method"
            placeholder="Select Method"
            options={retrievalMethodOptions}
            selectedKey={filterRetrievalMethod}
            onChange={(e, item) =>
              this.setState({ filterRetrievalMethod: item.key })
            }
          />

          <StandardDropdown
            label="Product"
            placeholder="Select Products"
            options={this.productOptions}
            selectedKeys={this.state.selectedProducts}
            onChange={(e, item) => {
              const selected = this.state.selectedProducts.includes(item.key)
                ? this.state.selectedProducts.filter(p => p !== item.key)
                : [...this.state.selectedProducts, item.key];
              this.setState({ selectedProducts: selected });
            }}
            multiSelect
          />

          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <StandardDropdown
              label="Permission Type"
              placeholder="Select Type"
              options={permissionTypeOptions}
              selectedKey={this.state.filterPermissionType}
              onChange={(e, item) =>
                this.setState({ filterPermissionType: item.key })
              }
            />

            <StandardSearchBox
              label="Specific Permission"
              placeholder="e.g. Mail.Send"
              value={filterPermissionName}
              onChange={(newValue) => {
                this.setState({
                  filterPermissionName: newValue,
                  permissionSearchMode: newValue ? "" : "",
                });
              }}
              disabled={this.state.filterPermissionType === "All"}
            />

            {filterPermissionName && (
              <div style={{
                display: "flex",
                gap: "0px",
                padding: "0px",
                backgroundColor: "#ffffff",
                borderRadius: "4px",
                border: "1px solid #d0d0d0",
                height: "32px",
              }}>
                  <button
                    onClick={() => this.setState({ permissionSearchMode: "has" })}
                    style={{
                      flex: 1,
                      padding: "0px 12px",
                      border: "none",
                      backgroundColor: this.state.permissionSearchMode === "has" ? "#0078d4" : "transparent",
                      color: this.state.permissionSearchMode === "has" ? "white" : "#333",
                      fontWeight: "500",
                      cursor: "pointer",
                      borderRadius: "3px 0px 0px 3px",
                      transition: "all 0.2s",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                    }}>
                    HAS THESE PERMISSIONS
                  </button>

                  <div style={{ width: "1px", backgroundColor: "#d0d0d0" }}></div>

                  <button
                    onClick={() => this.setState({ permissionSearchMode: "exclude" })}
                    style={{
                      flex: 1,
                      padding: "0px 12px",
                      border: "none",
                      backgroundColor: this.state.permissionSearchMode === "exclude" ? "#0078d4" : "transparent",
                      color: this.state.permissionSearchMode === "exclude" ? "white" : "#333",
                      fontWeight: "500",
                      cursor: "pointer",
                      borderRadius: "0px 3px 3px 0px",
                      transition: "all 0.2s",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                    }}>
                    DOESN'T HAVE THESE PERMISSIONS
                  </button>
                </div>
            )}

            {filterPermissionName && !this.state.permissionSearchMode && (
              <div style={{ color: "#d32f2f", fontSize: "12px", fontWeight: "500", whiteSpace: "nowrap" }}>
                Please select one of these options
              </div>
            )}
          </div>

          <StandardButton
            text="Get Permissions"
            disabled={regionNameChosenPermissions === "" || (filterPermissionName && !this.state.permissionSearchMode)}
            onClick={() =>
              this.setState({ currentPage: 1 }, () =>
                this.getCustomerPermissions(),
              )
            }
          />

          {messagePermissions && (
            <StatusMessage type="message">{messagePermissions}</StatusMessage>
          )}

          {errorPermissions && (
            <StatusMessage type="error">{errorPermissions}</StatusMessage>
          )}

          {permissionsData && permissionsData.length > 0 && (
            <div
              style={{
                marginTop: Theme.spacing.lg,
                marginLeft: `-${Theme.layout.contentPadding}`,
                marginRight: `-${Theme.layout.contentPadding}`,
                padding: Theme.layout.contentPadding,
                width: `calc(100% + ${Theme.layout.contentPadding} + ${Theme.layout.contentPadding})`,
                boxSizing: "border-box",
              }}
            >
              {/* Permission Search Mode Status */}
              {filterPermissionName && (
                <div style={{
                  marginBottom: "15px",
                  padding: "10px 12px",
                  backgroundColor: this.state.permissionSearchMode === "exclude" ? "#fff4ce" : "#e7f3ff",
                  border: `2px solid ${this.state.permissionSearchMode === "exclude" ? "#ffb900" : "#0078d4"}`,
                  borderRadius: "4px",
                  fontWeight: "500",
                  color: this.state.permissionSearchMode === "exclude" ? "#a65628" : "#003478"
                }}>
                  {this.state.permissionSearchMode === "exclude"
                    ? `⚠️ Showing tenants that don't have these permissions: "${filterPermissionName}"`
                    : `✓ Showing tenants that have these permissions: "${filterPermissionName}"`
                  }
                </div>
              )}

              {/* Pagination Info */}
              <div
                style={{
                  marginBottom: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#f8f9fa",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #dee2e6",
                }}
              >
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {(() => {
                    if (!permissionsData || totalCount === 0) {
                      return "Showing 0 to 0 of 0 records";
                    }
                    const start = (currentPage - 1) * pageSize + 1;
                    const end = Math.min(currentPage * pageSize, totalCount);
                    const validStart = Math.min(start, end, totalCount);
                    const validEnd = Math.max(validStart, end);
                    return `Showing ${validStart} to ${validEnd} of ${totalCount} records`;
                  })()}
                </div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  Page {currentPage} of {totalPages}
                </div>
              </div>

              {/* Table */}
              {this.renderPermissionsTable()}

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "20px",
                    padding: "15px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <StandardButton
                    text="Previous"
                    disabled={currentPage === 1}
                    onClick={this.handlePreviousPage}
                  />

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      margin: "0 15px",
                    }}
                  >
                    {this.renderPageNumbers()}
                  </div>

                  <StandardButton
                    text="Next"
                    disabled={currentPage === totalPages}
                    onClick={this.handleNextPage}
                  />
                </div>
              )}
            </div>
          )}

          {permissionsData && permissionsData.length === 0 && (
            <StatusMessage type="warning">
              No permissions found matching your criteria.
            </StatusMessage>
          )}
        </StandardScreen>
      </PageLayout>
    );
  }
}

export default AADToggle;
